import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import CsInformationModal from '../../models/CsInformationModal.js';
import beautifyColumnKey from './utils/beautifyColumnKey';
import ExpandablePanel from './components/ExpandablePanel';

const InformationComponent = (props) => {
  const { csInformation } = props;
  const csDiagnosticsObj = useMemo(() => {
    const obj = new CsInformationModal(csInformation).toStateJson();
    delete obj.errors;
    return obj;
  }, [csInformation]);

  const rowCount = Object.keys(csDiagnosticsObj).length;

  const headerActions = (
    <span className="cs-row-count">
      {rowCount} fields
    </span>
  );

  return (
    <ExpandablePanel title="INFORMATION" compactHeight={220} fixedHeight={220} headerActions={headerActions}>
      <table className="table table-sm mb-0 cs-table">
        <tbody>
          {rowCount > 0 ? (
            Object.keys(csDiagnosticsObj).map((key) => {
              if (key === 'latitude' || key === 'longitude') {
                if (key === 'longitude') {
                  return (
                    <tr key={key}>
                      <td
                        rowSpan={2}
                        style={{ minWidth: '200px' }}
                        className="cs-info-key fw-medium align-middle"
                      >
                        Latitude Longitude
                      </td>
                      <td rowSpan={2} style={{ minWidth: '200px' }} className="cs-info-value align-middle">
                        <a
                          href={`https://www.google.com/maps?q=${csDiagnosticsObj.latitude},${csDiagnosticsObj.longitude}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-success text-decoration-none"
                        >
                          <FontAwesomeIcon icon={faLocationDot} className="me-2" />
                          {csDiagnosticsObj.latitude}, {csDiagnosticsObj.longitude}
                        </a>
                      </td>
                    </tr>
                  );
                }
                return <tr key={key} />;
              }
              return (
                <tr key={key}>
                  <td rowSpan={2} style={{ minWidth: '200px' }} className="cs-info-key fw-medium">
                    {beautifyColumnKey(key)}
                  </td>
                  <td rowSpan={2} style={{ minWidth: '200px' }} className="cs-info-value">
                    {csDiagnosticsObj[key]}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={4} className="text-center bg-light">
                No matching records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </ExpandablePanel>
  );
};

export default InformationComponent;
